import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'wk-error',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.scss']
})
export class ErrorsComponent implements OnInit {

  data: any; // TODO: use proper interface.
  public title = 'error.ERROR_OCCURRED';
  public button = 'error.BACK_TO_HOME_PAGE';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    const data = this.activatedRoute.snapshot.paramMap.get('token');
    if (data) {
      const cooked = JSON.parse(atob(data));
      // TODO
      this.data = cooked;

      if (this.data.navigation) {
        this.redirect();
      }
    }
  }

  /**
   * @author duccn
   * @date 19/02/2019
   * @description redirect user to specific route if provided.
   */
  // TODO: handle countdown and display to the view.
  redirect() {
    setTimeout(() => {
      this.router.navigate(this.data.navigation);
    }, this.data.delay ? (this.data.delay * 1000) : 0);
  }
}
